<script>
  import HeadshotCircle from '@/components/headshot-circle.vue'
  export default {
    name: 'director-profile',
    components: {
      HeadshotCircle
    }
    // data: () => ({}),
    // computed: {},
    // methods: {},
    // created() {}
  }
</script>

<template>
  <v-sheet color="transparent" id="director" class="d-flex flex-column align-center mt-16">
    <headshot-circle
      :headshotData="{
        name: 'Matthew Wuthenow',
        title: 'Director',
        headshot: 'https://media.eipl.org/site/images/pages/about/board/matt.jpg'
      }"
    ></headshot-circle>
    <!-- <v-sheet max-width="650" outlined class="bordered primary--text rounded-lg pa-6 mt-4">
      <p>
        <em>
          As the world changes around us, we are forever evolving to better meet your needs and that of the whole community. Serving you is our first and foremost concern, however,
          in response to these uncertain financial times, we are proposing a budget that does not anticipate any raise in your taxes. This is the Library’s third year of no tax
          increases, and hopefully we can continue this trend into the foreseeable future. On page two of this newsletter is additional information about the Library’s proposed
          budget. Please consider attending the budget hearing on Thursday, March 23rd and come out and vote on Tuesday April 4th. After ten years of dedicated service to the
          community, John E. Flynn has decided not to run for reelection to the Library Board of Trustees. On behalf of the community, staff and the other members of the Board, I
          want to thank John for his time, insight and support over these many years. You will be missed!
        </em>
      </p>
      <p>-Matthew Wuthenow</p>
    </v-sheet> -->
  </v-sheet>
</template>

<style scoped></style>
